import { render, staticRenderFns } from "./death.vue?vue&type=template&id=67ab7f7c&scoped=true"
import script from "./death.vue?vue&type=script&lang=js"
export * from "./death.vue?vue&type=script&lang=js"
import style0 from "./death.vue?vue&type=style&index=0&id=67ab7f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ab7f7c",
  null
  
)

export default component.exports